import { useStore, create } from "zustand";

import { AmpolService, Position } from "./types";

interface RefinementStore {
  position: null | Position;
  name: null | string;
  services: NonNullable<AmpolService["services"]> | null;
  setServices: (services: AmpolService["services"] | null) => void;
  bounds: [Position, Position] | null;
  setBounds: (id: [Position, Position] | null) => void;
  setGeocodeContext: (name: string | null, pos: Position | null) => void;
}

const refinementStore = create<RefinementStore>()((set, get) => ({
  position: null,
  name: null,
  services: null,
  bounds: null,
  setServices: (services) => set({ services }),
  setBounds: (bounds) => set({ bounds }),
  setGeocodeContext: (name, pos) => set({ name, position: pos }),
}));

export function useSubscribe() {
  return refinementStore.subscribe;
}

function useRefinementStore(): RefinementStore;
function useRefinementStore<T>(
  selector: (state: RefinementStore) => T,
  equals?: (a: T, b: T) => boolean
): T;
function useRefinementStore<T>(
  selector?: (state: RefinementStore) => T,
  equals?: (a: T, b: T) => boolean
) {
  return useStore(refinementStore, selector!, equals);
}

export default useRefinementStore;
